import { FloatingFormItem } from '@/components/_common';
import { titleIdentificationTypePaymentCaixa } from '@/components/Registry/BankAccounts/Config/ConfigBankSlipForm/PaymentTypeCaixaSelect/titleIdentificationTypePaymentCaixa';
import { bankConfig } from '@/core/domain/financial/Boletos/Boletos.dictionary';
import { Col, Select } from 'antd';

interface Props {
  bankCode?: string;
}

export default function PaymentTypeCaixaSelect(props: Props) {
  const bankMapFields = props.bankCode ? bankConfig[props.bankCode] : null;

  if (!bankMapFields?.fields.titleIdentificationTypePayment?.visible)
    return null;

  return (
    <Col span={24} md={12} lg={6} xxl={4}>
      <FloatingFormItem
        label="Tipo de pagamento"
        name={['general', 'titleIdentificationTypePayment']}
      >
        <Select
          allowClear
          style={{ width: '100%' }}
          options={titleIdentificationTypePaymentCaixa.map((item) => ({
            value: item.code,
            label: `${item.code} - ${item.description}`,
          }))}
        />
      </FloatingFormItem>
    </Col>
  );
}
